import {useFlags, useFlagsLoaded} from '@product-web/flags'

export function useFeatureFlag() {
    const isLoaded = useFlagsLoaded()
    const flags = useFlags()
    return {isLoading: !isLoaded, isEnabled: flags.settingsApiKeys}
}
